import '../../../app.css';
import '../../game.css';

const React = require('react');
const ModalWindow = require('../../../../core/modal').default;
const assets = require('../../../../assets').default;
const { renderTwitterButton, getGameOverTitle } = require('../../../../core/twitter').default;
const { sound, soundType } = require('../../../../core/sound').default;

const styles = require('../../game.style').default;

// ============================

export default class gameOverComponent extends React.Component {
    renderContents() {
        const { gameState: { score, arrivalStage, continueCount } } = this.props;
        return (
            <div style={styles.modalStyle}>
                <div className="dialog">
                    <div className="dialog-header-bg">
                        <div className="dialog-header">Game Over</div>
                    </div>
                    <div className="dialog-contents">
                        <div className="dialog-row">
                            <div className="modal-messages">
                                <div className="modal-messages-header">Game Over...</div>
                                <div className="modal-messages-content">王女メア：</div>
                                <div className="modal-messages-content">残念ですが、時間切れになってしまいました。再びの挑戦をお願いします。。。</div>
                            </div>
                            <div className="modal-illuast">
                                <img className="modal-illuast-img" src={assets.ModalMea04} />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="modal-footer-buttons">
                            {continueCount > 0
                                ? <div className="btn-modal" onClick={() => {
                                    sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                                    this.props.handleContinueClick(arrivalStage)
                                }}>コンティニュー×{continueCount}</div>
                                : <div className="btn-modal-disable" >コンティニュー×{continueCount}</div>
                            }
                            <div className="btn-modal" onClick={() => {
                                sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                                this.props.handleTitleClick()
                            }}>探索を終了する</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return <ModalWindow
            isModalOpen={this.props.isModalOpen}
            isCloseOutOfArea={false}
            contents={this.renderContents()}
        />
    }
}